import { forwardRef, ReactNode, useContext } from 'react';
import { EditorMode } from '../../../../util/EditModeUtils';
import { DocumentLayout } from '../../DocumentLayout/DocumentLayout';
import {
  DocumentOverviewContext,
  EditorStatus,
  EditorStatusContext,
} from '../Context';

export const DocEditorSideBarWrapper = forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => {
  const { qualioDocument, currentEditorMode, commentsPermission } = useContext(
    DocumentOverviewContext,
  );

  const { docEditorStatus } = useContext(EditorStatusContext);

  const shouldShowMultiRootEditor =
    qualioDocument.editor_version?.includes('multiroot');

  const isEditMode =
    currentEditorMode !== EditorMode.VIEW &&
    docEditorStatus !== EditorStatus.CONNECTING;

  return (
    <DocumentLayout
      ref={ref}
      isEditMode={isEditMode}
      sections={qualioDocument.sections}
      sectionTitlesVisible={qualioDocument.text_sections_titles_visible}
      commentsPermission={commentsPermission}
      editorStatus={docEditorStatus}
      contentId="documentEditorContent"
      commentControlId="documentCommentControl"
      sidebarId="commentsSidebar"
      dataCy={{
        content: 'documentEditorContent',
        commentControl: 'documentCommentControl',
        commentButton: 'comment-button',
        commentSidebar: 'commentsSidebar',
      }}
      isLandscape={qualioDocument.orientation === 'landscape'}
      isMultiRootEditor={shouldShowMultiRootEditor}
    >
      {children}
    </DocumentLayout>
  );
});
